// Application Configuration
export const MAX_PARTICIPANTS_PER_SLOT = parseInt(process.env.REACT_APP_MAX_PARTICIPANTS_PER_SLOT) || 35;
export const ADULT_PRICE = parseInt(process.env.REACT_APP_ADULT_PRICE) || 14;
export const CHILD_PRICE = parseInt(process.env.REACT_APP_CHILD_PRICE) || 11;
export const INSURANCE_PREMIUM = 15;

// Pricing Configuration
export const SINGLE_CLASS_PRICE = 150;
export const ADDITIONAL_CLASS_PRICE = 85;
export const FITNESS_ALL_DAYS_PRICE = 235;

// Discount Configuration
export const DISCOUNT_TYPES = {
  NONE: { value: "1", amount: 0, label: "Geen" },
  SMALL: { value: "2", amount: 10, label: "10 €" },
  LARGE: { value: "3", amount: 30, label: "30 €" }
};

// Time Slots Configuration
export const TIME_SLOTS = {
  1: "11u - 12u",
  2: "12u - 13u", 
  3: "13u - 14u",
  4: "14u - 15u",
  5: "15u - 16u",
  6: "16u - 17u",
  7: "17u - 18u",
  8: "18u - 19u",
  9: "19u - 20u30"
};

// EmailJS Configuration
export const EMAILJS_CONFIG = {
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_1j5khlc',
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_it7ltla',
  USER_ID: process.env.REACT_APP_EMAILJS_USER_ID || 'user_PPpSpfPeJ2bq8l4t9Al08'
};

// Form Validation Messages
export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: "Dit veld is verplicht",
  INVALID_EMAIL: "Voer een geldig e-mailadres in",
  RESERVATION_FULL: "Dit tijdslot is vol",
  RESERVATION_SUCCESS: "Reservering succesvol!",
  RESERVATION_ERROR: "Er is een fout opgetreden bij het reserveren"
};

// Social Media Links
export const SOCIAL_LINKS = {
  FACEBOOK: "https://www.facebook.com/danceatbeat.danceatbeat",
  INSTAGRAM: "https://www.instagram.com/dance_at_beat/",
  TIKTOK: "https://www.tiktok.com/@danceatbeatdansschool"
}; 